import { Persistency } from "@bounce/persistency"
import type { Nullable } from "@bounce/util"

import { AUTO_APPLIED_COUPONS, PERSISTED_THIRTY_DAYS_MS } from "../constants"
import type { ReferralCodes } from "../types"

type PersistOptions = {
  codes: ReferralCodes
  previousCodes: ReferralCodes
  cookieDomain?: Nullable<string>
}

const setReferralCookie = (key: string, value: string) =>
  Persistency.setCookie({
    key,
    value,
    expires: new Date(Date.now() + PERSISTED_THIRTY_DAYS_MS),
    path: "/",
  })

/**
 * - Web: Stored in browser cookies.
 * - Mobile: Stored in async storage.
 */
export const getPersistedCodes = async (): Promise<ReferralCodes> => {
  const persistedCouponCode = await Persistency.getCookie("coupon")
  const persistedReferralCode = await Persistency.getCookie("referral")
  const persistedRwgToken = await Persistency.getCookie("rwg_token")

  return {
    referral: persistedReferralCode ?? undefined,
    coupon: persistedCouponCode ?? undefined,
    rwgToken: persistedRwgToken ?? undefined,
  }
}

export const persist = async ({ codes, previousCodes, cookieDomain }: PersistOptions) => {
  if (codes.coupon) {
    if (AUTO_APPLIED_COUPONS.includes(codes.coupon)) return

    await Persistency.setCookie({
      key: "coupon",
      value: codes.coupon,
      path: "/",
      domain: cookieDomain || undefined,
    })
  }

  if (codes.referral && previousCodes.referral === undefined) {
    // Persist for 30 Days from 1st visit and have it not be overriden by the next visit
    await setReferralCookie("referral", codes.referral)
  }

  if (codes.rwgToken && previousCodes.rwgToken === undefined) {
    // Persist for 30 Days from 1st visit and have it not be overriden by the next visit
    await setReferralCookie("rwg_token", codes.rwgToken)
  }
}
